/** XP required to advance from `level` to `level + 1` — an increasing curve, not flat. */
export function xpRequiredForLevel(level, base, increment) {
    return base + (level - 1) * increment;
}
/**
 * Applies an XP grant to the current { xp, level } state, handling a single grant large
 * enough to cross multiple levels at once (not just +1) — XP always carries over past a
 * level-up rather than being reset or dropped.
 */
export function applyXpGrant(current, amount, base, increment) {
    let xp = current.xp + amount;
    let level = current.level;
    const levelsGained = [];
    let required = xpRequiredForLevel(level, base, increment);
    while (xp >= required) {
        xp -= required;
        level += 1;
        levelsGained.push(level);
        required = xpRequiredForLevel(level, base, increment);
    }
    return { xp, level, levelsGained };
}
